export const appScreen =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/app-screen.png';

export const airtelIcon =
  'https://giglassets.s3.eu-west-2.amazonaws.com/icons/Airtel.svg';

//   images
export const corporateImg =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/corporate.jpg';

export const cryptoImage =
  'https://giglassets.s3.eu-west-2.amazonaws.com/icons/cryptoimage.svg';

export const domesticImage =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/domestic.jpg';

export const ecommerceImage =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/ecommerce.jpg';

export const giggoRiderImage =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/giggo-rider.png';

export const overseaImage =
  'https://giglassets.s3.eu-west-2.amazonaws.com/images/overseas.png';

export const globacomIcon =
  'https://giglassets.s3.eu-west-2.amazonaws.com/icons/Globacom.png';
